var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('img',{staticClass:"page-404__icon",attrs:{"src":require("@/assets/icons/404.svg"),"alt":""}}),_c('div',{staticClass:"page-404__message"},[_c('QuizTitle',{attrs:{"title":_vm.message}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }